import { getRequest, postRequest } from '../config/axios-config';
import { apiRoutes, serverUrl } from '../constants/api-routes';

const getUsageRightRequests = (body: object) =>
  // eslint-disable-next-line
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getUsageRights,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const updateUsageRightRequests = (body: object) =>
  // eslint-disable-next-line
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.updateUsageRights,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const reviseUsageRights = (body: object) =>
  // eslint-disable-next-line
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.reviseUsageRights,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getNotifications = () =>
  // eslint-disable-next-line
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getNotifications
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const updateNotificationStatus = (body: object) =>
  // eslint-disable-next-line
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.updateNotificationStatus,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

export {
  getUsageRightRequests,
  updateUsageRightRequests,
  reviseUsageRights,
  getNotifications,
  updateNotificationStatus,
};
